
















































































































































// Vue
import { Component, Vue } from 'vue-property-decorator';

// Components
import ButtonInput from '@/components/ButtonInput.vue';
import GoatForm from '@/components/GoatForm.vue';
import ResourceLink from '@/components/ResourceLink.vue';
import SelectInput from '@/components/SelectInput.vue';
import Spinner from '@/components/Spinner.vue';

// Models
import AuthorityModel from '../models/Authority';
import BookModel from '../models/Book';
import CommentaryBookModel from '../models/CommentaryBook';
import LinkModel from '../models/Link';
import OptionModel from '../models/Option';
import RankingModel from '../models/Ranking';
import SeminaryModel from '../models/Seminary';

// Services
import AuthService from '../services/AuthService';
import BookInfoService from '../services/BookInfoService';
import HttpService, { HttpResponse, HttpError } from '../services/HttpService';
import BookInfoModel from '../models/BookInfo';

@Component({
  components: {
    ButtonInput,
    GoatForm,
    ResourceLink,
    SelectInput,
    Spinner,
  },
})
export default class Home extends Vue {
  private authorityOptions: OptionModel[] = [];
  private bookOptions: OptionModel[] = [];
  private rankings: RankingModel[] = [];
  private seminaryOptions: OptionModel[] = [];

  private selectedAuthorityId: number = -1;
  private selectedBookId: number = -1;
  private selectedCommentaryBookId: string = '';
  private selectedSeminaryId: number = -1;

  private isLoadingAuthorities: boolean = false;
  private isLoadingBooks: boolean = false;
  private isLoadingRankings: boolean = false;
  private isLoadingSeminaries: boolean = false;

  private loadingMessage: string = '';
  private loadingMessages: string[] = [
    'Finding the best commentaries...',
    'Scouring the codexes...',
    'Asking our pastor...',
    'Collecting recommendations...',
  ];

  public get canCreateRanking(): boolean {
    return true;
  }

  public get canGetRankings(): boolean {
    return !!this.selectedBookId && !!this.selectedSeminaryId;
  }

  public get bottomRankings(): RankingModel[] {
    let rankings: RankingModel[] = [];
    if (this.rankings.length > 5) {
      rankings = this.rankings.slice(5);
    }
    return rankings;
  }

  public get topRankings(): RankingModel[] {
    return this.rankings.slice(0, 5);
  }

  public get isAdmin(): boolean {
    return (
      !!AuthService && !!AuthService.userInfo && AuthService.userInfo.isAdmin
    );
  }

  public get isLoading(): boolean {
    return (
      this.isLoadingAuthorities ||
      this.isLoadingBooks ||
      this.isLoadingSeminaries
    );
  }

  private generateRankingLink(ranking: RankingModel): LinkModel {
    return new LinkModel(`/commentaries/${ranking.commentaryId}`);
  }

  private getBooks(): void {
    HttpService.get('api/books')
      .then((response: HttpResponse<BookModel[]>) => {
        let books = response.data;
        books = books.sort((a, b) => {
          return a.id - b.id;
        });
        this.bookOptions = [];
        if (books && books.length > 0) {
          this.selectedBookId = books[0].id;
          for (const book of books) {
            this.bookOptions.push(new OptionModel(book.id, book.name));
          }
        }
      })
      .catch((error: HttpError) => {
        this.bookOptions = [];
        console.error(error);
      })
      .finally(() => {
        this.isLoadingBooks = false;
      });
  }

  private getRankings(): void {
    if (!this.isLoadingRankings) {
      this.isLoadingRankings = true;
      this.setLoadingMessage();
      const params: Map<string, string> = new Map();
      params.set('bookId', this.selectedBookId.toString());
      params.set('seminaryId', this.selectedSeminaryId.toString());
      HttpService.get('api/rankings', true, params)
        .then((response: HttpResponse<RankingModel[]>) => {
          const rankings = response.data;
          this.rankings = [];
          for (const ranking of rankings) {
            BookInfoService.getBookInfo(ranking.commentaryIsbn)
              .then((bookInfo: BookInfoModel | null | undefined) => {
                if (!bookInfo) {
                  const splitName = ranking.commentaryName.split('-');
                  const author = splitName[splitName.length - 1].trim();
                  bookInfo = new BookInfoModel(
                    '',
                    '',
                    ranking.commentaryName,
                    [],
                    author,
                    ranking.commentaryIsbn,
                  );
                }
                ranking.bookInfo = bookInfo;
                this.rankings.push(ranking);
                this.sortRankings();
              })
              .catch((error: HttpError) => {
                const splitName = ranking.commentaryName.split('-');
                const author = splitName[splitName.length - 1].trim();
                ranking.bookInfo = new BookInfoModel(
                  '',
                  '',
                  ranking.commentaryName,
                  [],
                  author,
                  ranking.commentaryIsbn,
                );
                this.rankings.push(ranking);
                this.sortRankings();
              });
          }
        })
        .catch((error: HttpError) => {
          this.rankings = [];
          console.error(error);
        })
        .finally(() => {
          this.isLoadingRankings = false;
        });
    }
  }

  private getSeminaries(): void {
    this.isLoadingSeminaries = true;
    HttpService.get('api/seminaries')
      .then((response: HttpResponse<SeminaryModel[]>) => {
        const seminaries = response.data;
        this.seminaryOptions = [];
        if (seminaries && seminaries.length > 0) {
          this.selectedSeminaryId = seminaries[0].id;
          for (const seminary of seminaries) {
            if (!AuthService.userInfo || !AuthService.userInfo.isAdmin) {
              if (!seminary.name.includes('Mock')) {
                this.seminaryOptions.push(
                  new OptionModel(seminary.id, seminary.name),
                );
              }
            } else {
              this.seminaryOptions.push(
                new OptionModel(seminary.id, seminary.name),
              );
            }
          }
        }
      })
      .catch((error: HttpError) => {
        this.seminaryOptions = [];
        console.error(error);
      })
      .finally(() => {
        this.isLoadingSeminaries = false;
      });
  }

  private setLoadingMessage(): void {
    this.loadingMessage = this.loadingMessages[
      Math.floor(Math.random() * this.loadingMessages.length)
    ];
  }

  private sortRankings(): void {
    this.rankings.sort((x: RankingModel, y: RankingModel) => {
      return y.rank - x.rank;
    });
  }

  private mounted() {
    this.getBooks();
    this.getSeminaries();
  }
}
